module.exports = __webpack_public_path__ + "static/media/laptop.a821c35a.jpeg";